import { render, staticRenderFns } from "./itemBlock.vue?vue&type=template&id=28a299ae&scoped=true"
import script from "./itemBlock.vue?vue&type=script&lang=js"
export * from "./itemBlock.vue?vue&type=script&lang=js"
import style0 from "./itemBlock.vue?vue&type=style&index=0&id=28a299ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a299ae",
  null
  
)

export default component.exports